import { IRegionShort } from 'api/region/types';
import { Diagnostics } from 'util/diagnostics';
import { getRegionSlugsCache } from 'util/memcache';

let data: Array<IRegionShort> | undefined;

const loadFromBundledIndex = (tag: string): Array<IRegionShort> => {
  // eslint-disable-next-line global-require, import/no-dynamic-require
  const all = (require(`../../public/index/regions-${process.env.NEXT_PUBLIC_LANG}.json`).regions || []) as Array<IRegionShort>;
  const limit = Number(process.env.MEMCACHE_LIMIT_REGIONS);
  const from = Number(process.env.MEMCACHE_LIMIT_REGIONS_FROM) || 0;
  const limited = limit ? all.slice(from, limit) : all;
  Diagnostics.message({ message: `getStaticPaths used bundled index (${limited.length} regions)`, tag });
  return limited;
};

export const fetchRegionSlugs = async (tag: string) => {
  if (!data) {
    if (!process.env.VERCEL) {
      // No localhost memcache process exists on Vercel; skip the doomed
      // axios call and go straight to the bundled index.
      try {
        const cached = await getRegionSlugsCache();
        if (cached.data && cached.data.length) {
          data = cached.data;
          Diagnostics.message({ message: 'getStaticPaths used memcache', tag });
        }
      } catch (e: any) {
        Diagnostics.error({ message: 'getStaticPaths cache failed to load ', tag, error: e });
      }
    }
    if (!data) {
      data = loadFromBundledIndex(tag);
    }
  } else {
    Diagnostics.message({ message: 'getStaticPaths used in-memory data', tag });
  }
  Diagnostics.message({ message: `Region getStaticPaths has ${data?.length} regions`, tag });
  return data!.filter((v) => !v.domain);
};
